import { NavLink } from "@/layouts/AppLayout/types";
import { DOMAIN } from "@/hooks/useCapabilities";
import { Path } from "@/router";
import { isActivityType } from "../_utils";

export const getActivityTypeNavLinks = (
  activityTypeId: string,
  activityTypeTitle?: string
): Record<string, NavLink<Path>[]> => {
  const showActivitiesTab = !isActivityType(activityTypeTitle, "education-self-reported");

  const activityLinks = [
    ...(showActivitiesTab
      ? [
          {
            domain: DOMAIN.EVERYONE,
            label: "Activities",
            link: {
              to: "/activities/activity-types/:activityTypeId/activities" as const,
              params: { activityTypeId }
            },
            icon: "assignment"
          }
        ]
      : []),
    {
      domain: DOMAIN.EVERYONE,
      label: "Participants",
      link: {
        to: "/activities/activity-types/:activityTypeId/participants" as const,
        params: { activityTypeId }
      },
      icon: "group"
    },
    {
      domain: DOMAIN.EVERYONE,
      label: "All Activity Types",
      link: {
        to: "/activities/activity-types"
      },
      icon: "assignment",
      trailingIcon: "navigate_next",
      dividerBefore: true,
      externalLink: true
    }
  ] as NavLink<Path>[];

  return {
    "Manage Activity Type": activityLinks
  };
};
